module.exports = __webpack_public_path__ + "static/media/魷魚鬚便當.62af230b.jpg";